import CCwidget from './cc-widget.vue';
export default CCwidget;
